// removed by extract-text-webpack-plugin
module.exports = {"orderSummaryPayment":"pERk9","separator":"_3avDW","wrapper":"oHcwB","primaryInfo":"_1wgRm","heading":"_3ua75","itemInfoSecondary":"_3wXTy"};


//////////////////
// WEBPACK FOOTER
// ./components/OrderSummaryTotal/styles.scss
// module id = 690
// module chunks = 0